/**
 * Step-oriented computed properties for the guided report builder.
 */
const build_count_label = (component, count, singular, plural) => {
  const label = count === 1 ? singular : plural;
  return component.translate_label(`${count} ${label}`);
};

const build_data_step_title = (component) => {
  if (component.is_question_scope_report) {
    return component.translate_label("Questions");
  }
  return component.translate_label("Grouping");
};

const build_data_step_summary = (component) => {
  if (component.is_question_scope_report) {
    return component.question_setup_value;
  }
  return component.translate_label(component.non_question_scope_summary_description);
};

export default {
  show_builder_mode_toggle() {
    return false;
  },
  is_accordion_mode() {
    return false;
  },
  is_advanced_mode() {
    return false;
  },
  show_step_pills() {
    return false;
  },
  builder_steps() {
    return [
      {
        key: "basics",
        title: this.translate_label("Basics"),
        summary: `${this.selected_report_type_label} | ${this.selected_output_format_label}`,
      },
      {
        key: "scope",
        title: this.translate_label("Scope"),
        summary: `${this.scope_summary_value} | ${this.date_summary_value}`,
      },
      {
        key: "data_selection",
        title: build_data_step_title(this),
        summary: build_data_step_summary(this),
      },
      {
        key: "columns",
        title: this.translate_label("Columns"),
        summary: build_count_label(
          this,
          this.selected_field_ids.length,
          "column",
          "columns"
        ),
      },
      {
        key: "review",
        title: this.translate_label("Review"),
        summary: this.generated_report
          ? this.translate_label(
              this.generated_report.status?.display_name || "Completed"
            )
          : this.translate_label("Ready to generate"),
      },
    ];
  },
  current_step_index() {
    return this.builder_steps.findIndex((step) => step.key === this.current_step_key);
  },
  current_step() {
    return this.builder_steps[this.current_step_index] || this.builder_steps[0];
  },
  previous_step_key() {
    const previous_step = this.builder_steps[this.current_step_index - 1];
    return previous_step?.key || null;
  },
  next_step_key() {
    const next_step = this.builder_steps[this.current_step_index + 1];
    return next_step?.key || null;
  },
  is_review_step() {
    return this.current_step_key === "review";
  },
  current_step_number() {
    const step_number = this.current_step_index + 1;
    return step_number;
  },
  total_step_count() {
    const total_steps = this.builder_steps.length;
    return total_steps;
  },
  step_progress_label() {
    const progress_label = this.translate_label(
      `Step ${this.current_step_number} of ${this.total_step_count}`
    );
    return progress_label;
  },
  review_generate_label() {
    if (this.generating_report) {
      return this.translate_label("Generating...");
    }
    if (this.is_editing_template) {
      return this.translate_label("Update template and generate");
    }
    return this.translate_label("Generate report");
  },
  footer_title() {
    const footer_title = this.translate_label("Current step");
    return footer_title;
  },
  footer_value() {
    const footer_value = this.current_step?.title;
    return footer_value;
  },
  footer_description() {
    const footer_description = this.current_step?.summary;
    return footer_description;
  },
};
